import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Alert } from 'react-bootstrap';
import { object } from 'yup';
import withForm from '../../../../../../admin/hocs/withForm';
import Translation from '../../../../../components/stateless/Translation';
import CheckoutSubmitButton from '../CheckoutSubmitButton';
import {
  TRACK_CLICK_CHECKOUT_STEP_FIVE_SUBMIT,
} from '../../../../../../src/web/utils/dataLayer';
import ApplyPromotion from '../ApplyPromotion/ApplyPromotion';
import Price from '../../../../../components/stateless/Price';

const propTypes = {
  formError: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  facility: PropTypes.shape().isRequired,
  receipt: PropTypes.shape({
    totalAmount: PropTypes.number.isRequired,
  }),
  checkPromoCode: PropTypes.func.isRequired,
  checkingPromoCode: PropTypes.bool.isRequired,
  checkPromoCodeData: PropTypes.shape({
    success: PropTypes.bool.isRequired,
    discountPlanId: PropTypes.string,
  }),
  appliedPromotion: PropTypes.shape(),
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  receipt: undefined,
  checkPromoCodeData: undefined,
  appliedPromotion: undefined,
};

const FORM_SUBMIT_TYPES = {
  payment: 'payment',
  promo: 'promo',
};

const UkCompleteRental = ({
  submitForm,
  submitting,
  formError,
  facility,
  receipt,
  checkPromoCode,
  checkingPromoCode,
  checkPromoCodeData,
  appliedPromotion,
  removeAppliedPromotion,
}) => {
  const handleFormSubmit = (event) => {
    event.preventDefault();
    const paymentFormData = new FormData(event.target);
    const formValues = Object.fromEntries(paymentFormData.entries());

    if (event.nativeEvent.submitter.value === FORM_SUBMIT_TYPES.payment) {
      submitForm();
    } else if (event.nativeEvent.submitter.value === FORM_SUBMIT_TYPES.promo) {
      checkPromoCode(
        facility.id,
        facility.unitGroup.id,
        formValues.promoCode,
      );
    }
  };

  return (
    <form onSubmit={handleFormSubmit}>
      {
        formError ? (
          <Alert bsStyle="danger">
            <Translation
              id="widgets.checkout.formError"
              defaultMessage="An error was encountered when submitting the form. Please try again."
            />
          </Alert>
        ) : null
      }
      <Row>
        <Col xs={12}>
          <div className="font-bold !text-black">
            <Translation
              id="widgets.checkout.payLater.firstMonthTotal"
              defaultMessage="Your 1st Month Total"
            />
          </div>
          <div className="mb-5">
            <Price
              currency={facility.currency}
              locale={facility.currencyLocale}
              value={receipt.totalAmount}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className="mt-4">
            <ApplyPromotion
              appliedPromotion={appliedPromotion}
              checkPromoCodeData={checkPromoCodeData}
              checkingPromoCode={checkingPromoCode}
              formSubmitType={FORM_SUBMIT_TYPES.promo}
              removeAppliedPromotion={removeAppliedPromotion}
              submitting={submitting}
            />
          </div>

          <div className="mt-2 mb-4">
            <p className="text-sm text-gray-500">
              <Translation
                id="widgets.checkout.payLater.info"
                defaultMessage="You are renting this unit. Complete payment on the next step to gain access to your unit."
              />
            </p>
          </div>
          <CheckoutSubmitButton
            submitLabel={{
              id: 'widgets.checkout.payLaterButton.submit',
              defaultMessage: 'Rent My Unit',
            }}
            submitting={submitting}
            submittingLabel={{
              id: 'widgets.checkout.payLaterButton.submitting',
              defaultMessage: 'Renting...',
            }}
            disabled={checkingPromoCode}
            {...TRACK_CLICK_CHECKOUT_STEP_FIVE_SUBMIT}
            name="submitType"
            value={FORM_SUBMIT_TYPES.payment}
          />
        </Col>
      </Row>
    </form>
  );
};

UkCompleteRental.propTypes = propTypes;
UkCompleteRental.defaultProps = defaultProps;

export default withForm({
  mapPropsToValues: () => ({}),
  validationSchema: object().shape({}),
  handleSubmit: (formPayload, formikBag) => (
    formikBag.props.onSubmit(
      formPayload,
      formikBag.props.currentStep,
      formikBag.props.nextStep,
      formikBag.props.scrollToRef,
    )
  ),
})(UkCompleteRental);
